// 昆仑万维官网数据

export const STATS = [
  { value: "4亿", label: "全球月活用户", sublabel: "Global MAU", mono: true },
  { value: "100+", label: "覆盖国家地区", sublabel: "Countries & Regions", mono: true },
  { value: "91%", label: "海外收入占比", sublabel: "Overseas Revenue", mono: true },
  { value: "2008", label: "成立年份", sublabel: "Founded", mono: true },
];

export const BUSINESSES = [
  {
    id: "agi",
    icon: "🤖",
    title: "AGI 与 AIGC",
    subtitle: "天工 AI 平台",
    description:
      "以「ALL in AGI」战略为引领，构建覆盖 AI 智能助手、AI 视频、AI 音乐、AI 游戏、AI 社交的多元化 AIGC 产品矩阵，多项技术指标登顶全球 SOTA。",
    highlights: ["天工超级智能体", "SkyReels V4", "Mureka O1", "Matrix-Game 3.0"],
    color: "from-blue-600/20 to-cyan-500/10",
    borderColor: "border-blue-500/30",
  },
  {
    id: "opera",
    icon: "🌐",
    title: "海外信息分发与元宇宙",
    subtitle: "Opera 平台",
    description:
      "旗下 Opera 浏览器在纳斯达克上市，深耕海外信息分发、元宇宙及短剧赛道，2024 年实现营业收入 4.8 亿美元，同比增长 21.1%。",
    highlights: ["Opera 浏览器", "DramaWave 短剧", "Star Group 音频社交", "海外广告变现"],
    color: "from-orange-500/20 to-amber-400/10",
    borderColor: "border-orange-400/30",
  },
  {
    id: "invest",
    icon: "💡",
    title: "科技股权投资",
    subtitle: "昆仑资本",
    description:
      "昆仑资本专注于全球科技领域战略投资，聚焦 Fintech、直播、电商、二次元等前沿赛道，持续捕捉全球数字经济增长红利。",
    highlights: ["Fintech 领域", "直播电商", "二次元内容", "全球科技布局"],
    color: "from-purple-600/20 to-violet-500/10",
    borderColor: "border-purple-500/30",
  },
];

export const PRODUCTS = [
  {
    name: "天工超级智能体",
    nameEn: "Skywork Super Agents",
    category: "AI 智能体",
    description: "登顶 GAIA 评测榜单，一站式生成文档、PPT、表格，支持 Deep Research 与多模态任务。",
    badge: "GAIA #1",
    badgeType: "gold" as const,
    icon: "⚡",
  },
  {
    name: "SkyReels V4",
    nameEn: "AI Video Platform",
    category: "AI 视频",
    description: "全链路 AI 视频创作平台，支持 60 秒以上长视频生成，SkyReels-A1 实现精准表情迁移。",
    badge: "视频 SOTA",
    badgeType: "blue" as const,
    icon: "🎬",
  },
  {
    name: "Mureka O1",
    nameEn: "AI Music Platform",
    category: "AI 音乐",
    description: "全球首个音乐推理大模型，V7.5 音质再次翻倍，Mureka 平台已服务数百万音乐创作者。",
    badge: "全球首创",
    badgeType: "green" as const,
    icon: "🎵",
  },
  {
    name: "Linky",
    nameEn: "AI Social App",
    category: "AI 社交",
    description: "AI 驱动的社交应用，让每一个用户都能与 AI 角色建立真实情感连接，重塑数字社交体验。",
    badge: "全球发行",
    badgeType: "blue" as const,
    icon: "💬",
  },
  {
    name: "Matrix-Game 3.0",
    nameEn: "World Model",
    category: "AI 游戏",
    description: "交互式游戏世界模型，通过自回归扩散即时生成长视频游戏画面，Matrix-3D 支持全向可探索 3D 世界。",
    badge: "世界模型",
    badgeType: "purple" as const,
    icon: "🎮",
  },
  {
    name: "Skywork-R1V3",
    nameEn: "Multimodal Reasoning",
    category: "基础模型",
    description: "开源最强多模态推理模型（38B），在 MMMU 和 OlympiadBench 上实现开源最佳性能。",
    badge: "开源 SOTA",
    badgeType: "gold" as const,
    icon: "🧠",
  },
];

export const TIMELINE = [
  { year: "2008", event: "昆仑万维成立", detail: "以页游研发与全球发行为起点，成为中国最早进军海外市场的游戏厂商之一。" },
  { year: "2015", event: "登陆创业板", detail: "于深交所创业板上市（股票代码：300418），战略投资 Opera 和 Grindr，全球化布局提速。" },
  { year: "2018", event: "Opera 纳斯达克上市", detail: "旗下 Opera 浏览器在美国纳斯达克成功上市，全球互联网平台版图持续扩大。" },
  { year: "2022", event: "ALL in AGI 战略", detail: "正式确立「ALL in AGI 与 AIGC」核心战略，开启大语言模型与 AIGC 全面技术研发。" },
  { year: "2023", event: "天工大模型发布", detail: "天工系列大模型正式发布，开源 SkyMusic、SkyText 等五个项目，天工 SkyAgents 平台上线。" },
  { year: "2024", event: "AIGC 商业化突破", detail: "SkyReels、Mureka 相继实现商业化，海外收入占比升至 91%，Opera 营收 4.8 亿美元。" },
  { year: "2025", event: "超级智能体登顶", detail: "天工超级智能体登顶 GAIA 评测，Mureka O1 成全球首个音乐推理大模型，月活超 500 万。" },
  { year: "2026", event: '"3+1" 生态升级', detail: "发布 AGI 战略升级，四大 SOTA 模型（视频/音乐/游戏世界/多模态）+ 超级智能体全面商业化。" },
];

export const MODELS = [
  { name: "Skywork-R1V3-38B", desc: "开源最强多模态推理模型", tag: "MMMU SOTA" },
  { name: "Skywork-UniPic 1.0", desc: "统一自回归多模态模型", tag: "理解+生成+编辑" },
  { name: "SkyReels-A1", desc: "表情迁移视频生成模型", tag: "60s+ 视频" },
  { name: "Matrix-3D", desc: "全向可探索 3D 世界生成", tag: "全景世界" },
  { name: "Skywork-SWE-32B", desc: "代码智能体模型", tag: "SWE-bench SOTA" },
  { name: "Mureka O1", desc: "音乐推理大模型", tag: "全球首创" },
];
